// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsFundsHoldingsComparablesModule } from './app.module';
bootstrapAppModule(MutualFundsFundsHoldingsComparablesModule);
